/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type DesignProfileStatus = "ACTIVE" | "DELETED" | "NEW" | "PENDING" | "%future added value";
export type HeaderRoot_viewer = {
    readonly geography?: {
        readonly " $fragmentRefs": FragmentRefs<"ProfileHeaderData_geography">;
    } | null;
    readonly tradeFirms: ReadonlyArray<{
        readonly serviceId: string | null;
        readonly profileStatus: DesignProfileStatus | null;
        readonly publicProfile: {
            readonly splashPhoto: string | null;
            readonly profilePhotoId: string | null;
            readonly designProjectsCount: number | null;
        } | null;
        readonly " $fragmentRefs": FragmentRefs<"ProfileHeaderBreadcrumbs_tradeFirm" | "ProfileHeaderData_tradeFirm" | "ProgressTour_tradeFirm">;
    } | null> | null;
    readonly " $refType": "HeaderRoot_viewer";
};
export type HeaderRoot_viewer$data = HeaderRoot_viewer;
export type HeaderRoot_viewer$key = {
    readonly " $data"?: HeaderRoot_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"HeaderRoot_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "firmUrlLabel"
    },
    {
      "kind": "RootArgument",
      "name": "isEditMode"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "HeaderRoot_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "urlLabel",
          "variableName": "firmUrlLabel"
        }
      ],
      "concreteType": "TradeFirmType",
      "kind": "LinkedField",
      "name": "tradeFirms",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "serviceId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "profileStatus",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TradeFirmPublicProfileType",
          "kind": "LinkedField",
          "name": "publicProfile",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "splashPhoto",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "profilePhotoId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "designProjectsCount",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProfileHeaderBreadcrumbs_tradeFirm"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProfileHeaderData_tradeFirm"
        },
        {
          "condition": "isEditMode",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ProgressTour_tradeFirm"
            }
          ]
        }
      ],
      "storageKey": null
    },
    {
      "condition": "isEditMode",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Geography",
          "kind": "LinkedField",
          "name": "geography",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ProfileHeaderData_geography"
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '12e32ef4d7352769eb0ced4cdbd84bb5';
export default node;
